import { Anchor, AnchorProps, ElementProps } from "@mantine/core";
import { ElementType } from "react";

export type LinkProps = AnchorProps &
  ElementProps<"a", keyof AnchorProps> & {
    component?: ElementType;
    to?: string;
  };

const Link = ({ style, component, ...rest }: LinkProps) => (
  <Anchor
    underline="always"
    c="var(--mantine-color-text-secondary)"
    style={{ cursor: "pointer", ...style }}
    component={(component ?? "a") as "a"}
    {...rest}
  />
);

export default Link;
